module.exports = {
    language: {
        name: '中文'
    },
    logo:{
        lastName:'Third Pole',
    },
    navBar: {
        home: 'Home',
        serve: 'Product Service',
        exhibition:'Exhibition',
        contact: 'About Us'
    },
    productService: {
        app: 'App development',
        hardware:'Hardware modification/construction',
        weiXin:'Wechat/Applet development',
        website:'Website/System construction',
        operate:'Online promotion',
        company:'Government system information construction'
    },
    serviceProcess: {
        our: 'Our',
        process: 'Services Procedure',
        chart: [
            'Communication',
            'Contracts Signing',
            'Designing',
            'Testing and Releasing',
            'Feedback',
            'Problem Solving ',
            'Prototype Design',
            'Product Engineering',
            'Payment',
        ]

    },
    aboutUs:{
        introduce:'Chengdu Third Pole was founded in 2015, concentrating on providing services for industry problem-solving, APP development, Wechat/Applet development, government/enterprises&institutions information Construction，etc.'
    },
    exhibition:{
      more:'more'
    },
    footer:{
        phone:'Telephone Number',
        email:'Email',
        contact:'Ms.Tang'
    },

}
